import styled from 'styled-components';
import { FlexColumn } from '../../../styled/common';
import { StepModalOption } from '../styled';
import { Breakpoints } from '../../../styled/constants';

export const LeasedOptionWrapper = styled(FlexColumn)`
  width: 100%;
  height: 100%;
  gap: 20px;

  @media (min-width: ${Breakpoints.smallDesktop}px) {
    flex-direction: row;
  }
`;

export const LeasedOption = styled(StepModalOption)`
  width: 100%;
  height: 100%;
`;
